import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'
//取得所有產線

let api = null
api = tools.mergeDeep(new ApiBase(), {
    apiGetCMSMX_GROUP() {
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI02/GetCMSMX_GROUP',
            method: 'post'
        })
    },
    apiGetVueMachineCalendar(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSKANUI02/GetVueMachineCalendar',
            method: 'post',
            data
        })
    },
})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        apiGetCMSMX_GROUP() {
            return https({
                url: 'http://localhost:12345/APSKANUI02/GetCMSMX_GROUP',
                method: 'post'
            })
        },
        apiGetVueMachineCalendar(data){
            return https({
                url: 'http://localhost:12345/APSKANUI02/GetVueMachineCalendar',
                method: 'post',
                data
            })
        },
    })
}

export default api